export const useValidation = (data, schema) => {
    let isValid = true;
    const invalidFields = {};

    for (const key of Object.keys(schema)) {
        if (typeof schema[key].validate === 'function') {
            const result = schema[key].validate(data[key], data);

            if (!result) {
                isValid = false;
                invalidFields[key] = true;
            }
        } else if (!data[key] || data[key].length === 0) {
            isValid = false;
            invalidFields[key] = true;
        }
    }

    return [isValid, invalidFields];
};